import React from 'react';
import timezone from 'moment-timezone';

const USER_TIMEZONE = timezone.tz.guess() || 'America/New_York';

const Text = ({ children }) => <p style={{ fontSize: 17 }}>{children}</p>;

const TextContent = ({
  contract, contractorSigned, clientSigned, currentUserIsContractor,
}) => {
  // if the contractor has signed, and the current view IS THE CONTRACTOR, then show this text

  // if both the client and contract have signed, show this
  if (clientSigned && contractorSigned) {
    return (
      <Text>
        You have both signed this contact! Thanks.
        <br />
      </Text>
    );
  }

  if (contractorSigned && currentUserIsContractor && contract.status !== 'SENT') {
    const date = timezone(contract.contractorSignDate)
      .tz(USER_TIMEZONE)
      .format('dddd, MMMM D');
    return (
      <Text>
        You signed this contract on {date}. <br />
        You're now ready to send it to your client.
      </Text>
    );
  }

  if (contractorSigned && currentUserIsContractor && contract.status === 'SENT') {
    const date = timezone(contract.contractorSignDate)
      .tz(USER_TIMEZONE)
      .format('dddd, MMMM D');
    return (
      <Text>
        You signed this contract on {date} and sent it to your client. <br />
        Now it's time to wait for them to review and sign.
      </Text>
    );
  }

  return null;
};

export default TextContent;



// WEBPACK FOOTER //
// ./src/routes/contract-view/SignedPDF/TextContent/index.js